import { render } from "./CreateSurveyModal.vue?vue&type=template&id=4bf12c1d"
import script from "./CreateSurveyModal.vue?vue&type=script&lang=js"
export * from "./CreateSurveyModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__